<template>
  <v-container fluid>
    <v-flex xs12>
      <ProfileDetails />
    </v-flex>
  </v-container>
</template>

<script>
import ProfileDetails from './../components/Profile/ProfileDetails.vue';

export default {
  name: 'profile',
  components: {
    ProfileDetails,
  },
  computed: {
  },
  methods: {
  },
  // mounted() {
  //   this.getSingleClient(this.clientId);
  // },
};
</script>
